module.exports = __webpack_public_path__ + "img/logo.5718c3a0.svg";